import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      invoiceType: "0", // 发票抬头，0：公司抬头；1：个人抬头
      activeIcon: require("../../../assets/invoice/invoice_type_selected.png"),
      inactiveIcon: require("../../../assets/invoice/invoice_type_unselect.png"),
      invoiceHeader: "", // 发票抬头，公司名称、个人名称等
      taxNo: "", // 税号
      email: "", // 邮箱地址
      address: "", // 注册地址
      telephone: "", // 注册电话
      bankName: "", // 银行名称
      bankNo: "", // 银行账号
      isSubmitting: false,
      content: ""
    };
  },
  created: function() {
    this.loadContent();
  },
  methods: {
    async loadContent() {
      // 加载发票内容
      const res = await httpRequest("/app/setting/info", "get", null);
      if (res !== null && res !== undefined && res.code === 200) {
        this.content = "*" + res.data.goodsTaxName + "*" + res.data.caption;
      }
    },
    // 加载当前问题的统一方法
    async applyInvoice() {
      if (this.isSubmitting) {
        return;
      }
      if (this.invoiceHeader.length === 0) {
        this.$alert(
          "请填写" + (this.invoiceType === "0" ? "单位名称" : "个人名称"),
          "警告"
        );
        return;
      }
      if (this.invoiceType === "0" && this.taxNo.length === 0) {
        this.$alert("请填写纳税人识别号", "警告");
        return;
      }
      if (this.email.length === 0) {
        this.$alert("请填写收票人邮箱", "警告");
        return;
      }

      this.isSubmitting = true;
      const params = {
        arId: this.$route.query.arId,
        invoiceType: this.invoiceType,
        personName: this.invoiceHeader,
        companyName: this.invoiceHeader,
        dutyParagraph: this.taxNo,
        address: this.address,
        phone: this.telephone,
        bankName: this.bankName,
        bankAccount: this.bankNo,
        money: this.$route.query.price,
        email: this.email
      };
      const res = await httpRequest("/app/invoice/invoice", "post", params);
      if (res !== null && res !== undefined && res.code === 200) {
        const _this = this;
        this.$alert(
          "提交成功，发票将在5分钟内送至您的邮箱，请及时查收",
          "提示",
          {
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            closeOnHashChange: false,
            callback: () => {
              _this.$router.back(-1);
            }
          }
        );
      }
      this.isSubmitting = false;
    },
    changeInvoiceType() {
      if (this.invoiceType === "1") {
        // 个人抬头
        this.invoiceHeader = "个人";
      } else {
        this.invoiceHeader = "";
      }
    }
  }
};
